import {Dialog, DialogContent, IconButton, makeStyles} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(() => ({
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '5px 16px',
    alignItems: 'center',
  },
  dialogTitle: {
    margin: 0,
    fontSize: '1rem',
  },
  dialogRoot: {
    padding: 0,
  },
}));

interface IPropsDialog {
  receiptUrl: string;
  open: boolean;
  onClose: (action: string) => void;
}

const ReceiptDialog: React.FC<IPropsDialog> = ({open, receiptUrl, onClose}) => {
  const {t} = useTranslation();
  const classes = useStyles();
  const handleCancel = () => {
    onClose('cancel');
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleCancel}
      maxWidth="md"
      fullWidth={true}
    >
      <div className={classes.titleBox}>
        <h2 className={classes.dialogTitle}>
          {t('consultar-comprovante.comprovante-votacao')}
        </h2>

        <IconButton
          edge="end"
          color="inherit"
          onClick={handleCancel}
          aria-label="close"
        >
          <Close />
        </IconButton>
      </div>
      <DialogContent classes={{root: classes.dialogRoot}}>
        <div
          style={{
            width: '100%',
            minWidth: '250px',
            height: 'auto',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'start',
          }}
        >
          <iframe
            id="ifmcontentstoprint"
            style={{
              position: 'relative',
              border: 'none',
              width: '100%',
              height: 'auto',
              minHeight: '60vh',
              overflow: 'scroll',
              alignItems: 'start',
              // left: '-100px',
              // top: '-100px',
            }}
            src={receiptUrl}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReceiptDialog;



// WEBPACK FOOTER //
// ./src/features/election/components/ReceiptDialog.tsx